import Vue from 'vue'
import Build from './BuildPopup.vue'
import { EventBus } from '../js/eventBus.js'

let EL = Vue.extend(Build)

export default class BuildPopup{
    constructor(params){
        let that = this
        let {
            id,
            name,
            position = {}
        } = params
        this.position = position
        this.flag = false
        this.EL = new EL({
            propsData:{
                name,
            }
        }).$mount()
        this.EL.flag = false
        this.EL.id = id
        this.EL.name = name
        this.EL.onOff = e =>{
            this.onOff()
        } 

        viewer.cesiumWidget.container.appendChild(this.EL.$el)
        this.addPostRender()
    }

    addPostRender(){
        viewer.scene.postRender.addEventListener(this.postRender, this)
    }

    postRender(){
        if(!this.EL.$el || !this.EL.$el.style) return 
        let canvasHeight = viewer.scene.canvas.height
        let windowPosition = new Cesium.Cartesian2()
        let cartesian3 = new Cesium.Cartesian3.fromDegrees(this.position.lon, this.position.lat, this.position.alt)
        Cesium.SceneTransforms.wgs84ToWindowCoordinates(viewer.scene, cartesian3, windowPosition)
        this.EL.$el.style.bottom = canvasHeight - windowPosition.y + 'px'
        this.EL.$el.style.left = windowPosition.x - this.EL.$el.offsetWidth / 2 + 'px'

        let cameraPosition = viewer.camera.position
        let height = viewer.scene.globe.ellipsoid.cartesianToCartographic(cameraPosition).height
        height += viewer.scene.globe.ellipsoid.maximumRadius

        if((Cesium.Cartesian3.distance(cameraPosition, cartesian3) < height) && viewer.camera.positionCartographic.height < 50000000){
            this.EL.$el.style.display = "block"
        }else{
            this.EL.$el.style.display = 'none'
        }
    }
    // 卸载dom
    windowClose(){
        if(this.EL){
            this.EL.$el.remove()
            this.EL.$destroy()
        }
        viewer.scene.postRender.removeEventListener(this.postRender, this)
    }

    onOff(){
        this.EL.flag  = !this.EL.flag
        let id = ''
        let name = ''
        if(this.EL.flag){
            id = this.EL.id 
            name = this.EL.name
            this.EL.$el.style.backgroundImage = "url("+require('../../../assets/img/buildSE.png')+")"
        }else{
            id = ''
            name = '选择楼宇'
            this.EL.$el.style.backgroundImage =  "url("+require('../../../assets/img/buildLogo.png')+")"
        }
        let build = {
            id,
            flag:this.EL.flag,
            name
        }
        EventBus.$emit('post',build)

        console.log(this.EL);
    }

    off(){
        this.EL.flag  = false
        this.EL.$el.style.backgroundImage =  "url("+require('../../../assets/img/buildLogo.png')+")"
    }

    show(){
        this.EL.flag  = true
    }

    hidden(){
        this.EL.$el.style.display = 'none'
        console.log('隐藏');
    }

    show(){
        this.EL.$el.style.display = 'block'
        console.log('显示');
    }
}